<script lang="ts">
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';
	import {
		closePositionInput,
		closePositionPostTradeDetails,
		currentClosePosition,
		loadingClosePositionPostTradeDetails
	} from '../popupsStore';
	import { marketPrices } from '$lib/util/marketHelper';

	export let fees: string = '0';

	$: positionPnl = new BigNumber(
		new BigNumber($marketPrices[$currentClosePosition.marketIdentifier]).minus(
			$currentClosePosition.avgEntryPrice
		)
	)
		.multipliedBy($currentClosePosition.size)
		.div(1e18)
		.plus($currentClosePosition.accruedFunding)
		.toString();
</script>

<div class="flex justify-between items-end">
	<div class="text-xs sm:text-sm text-fx-grey-400">Current PnL</div>
	<div
		class={`text-xs sm:text-sm text-fx-gradient-${new BigNumber(positionPnl).gte(0) ? '23' : '22'}`}
	>
		{addDollarSign(getNumBackInUnits(positionPnl, 18, 2))}
	</div>
</div>
<div class="flex justify-between items-end">
	<div class="text-xs sm:text-sm text-fx-grey-400">Fees</div>
	<div class="flex gap-2 items-center">
		{#if $loadingClosePositionPostTradeDetails}
			<ProcessingIcon />
		{/if}
		<div class="text-xs sm:text-sm text-fx-grey-300">
			${getNumBackInUnits(fees, 18, 2)}
		</div>
	</div>
</div>
